const isValidationError = (error) => (
    typeof error?.values === 'object'
    && error.values !== null
    && !Array.isArray(error.values)
    && Array.isArray(error.errorFields)
    && typeof error.outOfDate === 'boolean'
);

export const submitValidatedForm = (form, submit) => (
    form.validateFields()
        .then(submit, (error) => {
            if (!isValidationError(error)) {
                throw error;
            }
        })
);
